import Repository from "../../repository";

export default {
    GetList_CameraThermal: (payload) => Repository.post(`/api/ReportCameraThermals/GetList_CameraThermal`, payload),
    GetTop: (payload) => Repository.post(`/api/ReportCameraThermals/GetTop`, payload),
    GetDataByDate: (payload) => Repository.post(`/api/ReportCameraThermals/GetDataByDate`, payload),
}